module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/U48L7G/tc-custom/9781466845657.jpg?1737775942662",
      "alt": "This image is the cover for the book Pinocula, The Creature from My Closet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pinocula, The Creature from My Closet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For Rob Burnside, things are going pretty well. His friends are behaving, school isn't too bad, his family's getting along, and Janae, the girl of his dreams, occasionally notices him. Yep, life's okay—until the lying starts."), _c('br'), _vm._v("Meet Pinocula, the new creature from Rob's closet. He is a liar and a jokester and is determined to drive Rob crazy. Obert Skye doesn't let his fans down in this hilarious installment in The Creature from My Closet series, which started with "), _c('i', [_vm._v("Wonkenstein")]), _vm._v(" and "), _c('i', [_vm._v("Potterwookiee")]), _vm._v(".")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Obert Skye\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Henry Holt and Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0